import React, { useState, useEffect } from 'react';
import { Collapse, Table, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import PoaSostenibilidadMVD from './PoaSostenibilidadMVD';

const PoaSostenibilidadActividades = ({ nodo: initialNodo, codigoInterno, updateNodoInParent }) => {

    const [nodo, setNodo] = useState(initialNodo); // ✅ Estado para almacenar el JSON
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);

    // 🟢 Función para abrir el modal y seleccionar el registro
    const handleEditClick = (record) => {
        setSelectedRecord(record);
        setModalVisible(true);
    };

    // 🔥 Mantener `nodo` actualizado si `initialNodo` cambia en el padre
    useEffect(() => {
        setNodo(initialNodo);
    }, [initialNodo]);


    // ✅ Función para actualizar el JSON localmente con copia profunda
    const updateLocalPoaValue = (key, newValue) => {
        // 🔥 Hacemos una copia profunda del JSON antes de modificarlo
        let updatedNodo = structuredClone(nodo); // Alternativa: JSON.parse(JSON.stringify(nodo))

        // 🔎 Función para actualizar el nodo en la copia
        const updateNodeValue = (node) => {
            if (node.key === key) {
                node.noDeEjecutados = newValue;
                return true; // Se encontró y actualizó el nodo
            }
            if (node.children) {
                return node.children.some(updateNodeValue);
            }
            return false;
        };

        updatedNodo.children?.some(updateNodeValue);

        // 🔄 Actualiza el estado con el JSON modificado
        setNodo(updatedNodo);
        // 🔄 También actualiza el estado en el padre
        updateNodoInParent(updatedNodo);
    };

    const renderNodes = (nodes) => {
        return nodes.map(node => {
            const finalChildren = getFinalChildren(node.children || []);
            const onlyFinalChildren = node.children && node.children.every(child => child.isFinal === "yes");

            return {
                key: node.key,
                label: node.title,
                children: (
                    <>
                        {onlyFinalChildren ? renderFinalTable(finalChildren) : null}
                        {!onlyFinalChildren && node.children && node.children.length > 0 && (
                            <Collapse accordion items={renderNodes(node.children)} />
                        )}
                    </>
                )
            };
        });
    };

    const getFinalChildren = (children) => {
        return children.filter(child => child.isFinal === "yes");
    };

    const renderFinalTable = (finalNodes) => {
        if (finalNodes.length === 0) return null;

        const columns = [
            {
                title: 'Acciones',
                key: 'acciones',
                align: 'center',
                render: (text, record) => (
                    <Tooltip title="Editar acción de fortalecimiento">
                        <EditOutlined
                            style={{ fontSize: '18px', cursor: 'pointer', color: '#1890ff' }}
                            onClick={() => handleEditClick(record)}
                        />
                    </Tooltip>
                ),
            },
            { title: 'Título', dataIndex: 'title', key: 'title' },
            { title: 'Tipo Actividad', dataIndex: 'tipoActividad', key: 'tipoActividad' },
            { title: 'Actor', dataIndex: 'actor', key: 'actor' },
            { title: 'MDV', dataIndex: 'mdv', key: 'mdv' },
            { title: 'No. Actividades', dataIndex: 'noDeActividades', key: 'noDeActividades', align: 'center' },
            { title: 'Ejecutadas', dataIndex: 'noDeEjecutados', key: 'noDeEjecutados', align: 'center' },
            { title: '% Avance', dataIndex: 'avance', key: 'avance', align: 'center' }
        ];

        const dataSource = finalNodes.map(node => ({
            key: node.key,
            title: node.title,
            tipoActividad: node.tipoActividad || 'N/A',
            actor: node.actor || 'N/A',
            mdv: node.mdv || 'N/A',
            noDeActividades: node.noDeActividades || 0,
            noDeEjecutados: node.noDeEjecutados || 0,
            avance: node.noDeActividades > 0 ? ((node.noDeEjecutados / node.noDeActividades) * 100).toFixed(2) + '%' : '0%'
        }));

        return <Table columns={columns} dataSource={dataSource} pagination={false} />;

    };

    return (
        <div className="container-fluid">
            {nodo && nodo.children ? (

                <Collapse
                    accordion
                    items={renderNodes(nodo.children)}
                    style={{ maxWidth: "100%", overflow: "hidden" }} // 🔹 Evita que el Collapse limite el contenido
                />
            ) : (
                <p>No hay datos disponibles</p>
            )}

            {modalVisible && selectedRecord && (
                <PoaSostenibilidadMVD
                    isVisible={modalVisible}
                    onClose={() => setModalVisible(false)}
                    record={selectedRecord}
                    codigoInterno={codigoInterno}
                    updateLocalPoaValue={updateLocalPoaValue} // ✅ Pasamos la función al modal
                />
            )}
        </div>
    );
};

export default PoaSostenibilidadActividades;
